(function () {
    var transplant = {
        $element: null,
        $target: null,
        $order: null,
        $cloneData: null,
        $clonedContainer: null,
        vPort: 'screen-sm',

        init: function () {
            var transArray = $('[data-toggle="transplant"]');

            transArray.each(function (index) {
                var $this = $(this);

                transplant.$element = $this.data('transplant');
                transplant.$target = $($this.data('target'));
                transplant.$direction = $($this.data('direction'));
                transplant.$order = $this.data('transplant-order');

                transplant.$remove = $this.data('remove');
                transplant.$targetClass = $this.data('target-class');
                transplant.$classNames = $this.data('class-names');

                if (transplant.$direction === 'to' || typeof transplant.$direction === 'undefined') {
                    if (transplant.$element === 'self') {
                        transplant.$element = $this;
                    } else {
                        transplant.$element = $this.find(transplant.$element);
                    }
                    transplant.$cloneData = transplant.$element
                        .clone(true, true)
                        .removeAttr('data-toggle')
                        .attr('data-transplant-order', transplant.$order);

                    transplant.clone();
                    if (transplant.$targetClass) {
                        transplant.$target.find('.transplanted-clone').addClass(transplant.$targetClass);
                        transplant.$target.find('[data-pb-widget]')?.removeAttr('data-pb-widget');
                    }
                    if (transplant.$classNames) {
                        transplant.$element.addClass(transplant.$classNames);
                    }
                    if (transplant.$remove === true) {
                        transplant.remove();
                    }
                } else {
                    transplant.$target = $this;

                    const array = $this.data('target').split(',');
                    $.each(array, function (index, item) {
                        // go through selectors
                        transplant.$element = $(item);
                        transplant.$cloneData = transplant.$element
                            .clone(true, true)
                            .attr('data-transplant-order', transplant.$order);
                        transplant.clone();

                        if (transplant.$targetClass) {
                            transplant.$element.addClass(transplant.$targetClass);
                        }

                        if (transplant.$classNames) {
                            transplant.$target.find('.transplanted-clone').addClass(transplant.$classNames);
                        }
                        if (transplant.$remove === true) {
                            transplant.remove();
                        }
                    });
                }
            });
            transplant.order();
        },

        clone: function () {
            if (transplant.$element.hasClass('cloned')) return;

            if (transplant.$target.find('.transplanted-clone').length <= 0) {
                if (transplant.$target.is('ul')) {
                    transplant.$target.append('<li class="transplanted-clone"></li>');
                } else {
                    transplant.$target.append('<div class="transplanted-clone"></div>');
                }

                transplant.$clonedContainer = transplant.$target.find('.transplanted-clone');
                if (transplant.$cloneData.is('li')) {
                    transplant.$clonedContainer.append('<ul class="transplanted-clone__ul"></ul>');
                    transplant.$clonedContainer = transplant.$target
                        .find('.transplanted-clone__ul')
                        .addClass(transplant.$classNames);
                }
            }

            transplant.$clonedContainer.append(transplant.$cloneData);
            transplant.$element.addClass('cloned');

            transplant.cleanDuplicateID();
        },
        order: function () {
            var clonedItems = transplant.$clonedContainer.children();

            clonedItems.sort(function (a, b) {
                return $(a).data('transplant-order') - $(b).data('transplant-order');
            });

            transplant.$clonedContainer.html(clonedItems);
        },
        remove: function () {
            if (transplant.$target) {
                transplant.$element.remove();
            } else {
                transplant.$source.remove();
            }
        },
        cleanDuplicateID: function () {
            var id,
                targetFor,
                $controler,
                isMobile = false,
                clonedElement = transplant.$target;

            if (!clonedElement || clonedElement.length <= 0 || clonedElement.hasClass('cloned-with-ids')) return;

            id = clonedElement.attr('id');
            if (id) {
                clonedElement.attr('id', id + '-cloned');
            }
            clonedElement.find('[id]:not(.cloned-with-ids), [aria-owns]').each(function () {
                var $this = $(this);
                $this.addClass('cloned-with-ids');
                var id = $this.attr('id'),
                    ariaOwns = $this.attr('aria-owns');

                if (id) {
                    $this.attr('id', id + '-cloned');
                }
                if (ariaOwns) {
                    $this.attr(
                        'aria-owns',
                        $this
                            .attr('aria-owns')
                            .split(' ')
                            .map(id => id + '-cloned')
                            .join(' ')
                    );
                }
            });
            targetFor = clonedElement.attr('data-db-target-of');

            if (targetFor) {
                $controler = $('[data-db-target-for=' + targetFor + ']');
                if (!isMobile) {
                    $controler.attr({'aria-controls': targetFor + '-cloned'});
                }
                $(document).on(transplant.vPort + '-on', function () {
                    // Waiting for custom event that will be triggered by controller.js to activate responsive effects
                    isMobile = true;
                    $controler.attr({'aria-controls': targetFor});
                });
                $(document).on(transplant.vPort + '-off', function () {
                    // Waiting for custom event that will be triggered by controller.js to deactivate responsive effects
                    isMobile = false;
                    $controler.attr({'aria-controls': targetFor + '-cloned'});
                });
            }
        },
    };
    UX.transplant = transplant; // add to global namespace
})();
